const DropUploadFileHandler = (initFileUploadOnDrop, files) => {
    initFileUploadOnDrop(files)
}

export default DropUploadFileHandler